import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ExpedienteFiltroDto } from '../../../dto/expediente/expediente.filtro.dto';
import { FiltroDto } from '../../../dto/util/filtro-dto';
import { TableColumn } from '../../../dto/util/table-column';
import { ExpedienteSupersaludDto } from '../../../dto/expediente/expediente-supersalud.dto';
import { HistoricoSupersaludDto } from '../../../dto/expediente/historico-supersalud.dto';
import { ExpedienteService } from '../../../services/expediente.service';
import { UtilService } from '../../../services/util.service';
import { SolicitudDocumentosComponent } from '../solicitud-documentos/solicitud-documentos.component';
import { ModalService } from '../../../services/util/modal.service';
import { Constants } from '../../../constants/constants';
import { InfoPantallaDTO } from '../../../dto/util/infoPantallaDTO';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest } from 'rxjs';
import {EntidadService} from "../../../services/entidad.service";
import {EntidadApiResponse} from "../../../dto/entidad/entidad-response.dto";

@Component({
  selector: 'app-detalle-supersalud',
  templateUrl: './detalle-supersalud.component.html',
  styleUrl: './detalle-supersalud.component.scss',
})
export class DetalleSupersaludComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute);
  entidadId = 3;
  expedienteId = 0;
  usuarioCreadorId = 0;
  expedienteData: ExpedienteSupersaludDto = {};
  actuacionesSupersalud: HistoricoSupersaludDto[] = [];
  estadoProceso: string[] = [];
  columns: TableColumn[] = [];
  tamanoPagina = 5;
  totalPaginas = 0;
  paginaActual = 1;
  showButton = true;
  isCreator = false;
  public role = '';

  filtros: FiltroDto<ExpedienteFiltroDto> = {
    pagina: 1,
    tamanoPagina: 10,
    ordenarAsc: false,
    ordenarPor: 'fecha_creacion',
    filtros: {},
  };

  // Información de la pantalla y guía interactiva
  infoPantalla!: InfoPantallaDTO;
  // Multilenguaje
  tableText: any = {};
  guiaText: any = {};
  guiaSupersaludText: any = {};
  showGuia:boolean = true;
  entidad!: EntidadApiResponse;
  tipoDocumentoUsuario = '';
  numeroIdentificacion = '';
  constructor(
    private readonly service: ExpedienteService,
    private readonly router: Router,
    private readonly utilService: UtilService,
    private readonly modalService: ModalService,
    private readonly translate: TranslateService,
    private entidadService: EntidadService
  ) {
    const userData = sessionStorage.getItem(Constants.USER_TYPE);
    if (userData) {
      const parseObject = JSON.parse(userData);
      this.role = parseObject.Nombre;
    }
    // Multilenguaje

    combineLatest({
      tabla: this.translate.stream('detalle-supersalud'),
      guias: this.translate.stream('guias-interactivas'),
      guiaSuperSalud: this.translate.stream('guia-supersalud'),
    }).subscribe(({ tabla, guias, guiaSuperSalud }) => {
      // Asignar traducciones a variables
      this.tableText = tabla;
      this.guiaText = guias;
      this.guiaSupersaludText = guiaSuperSalud;
      this.ngOnInit();
    });
  }

  ngOnInit(): void {
    this.expedienteId = this.activatedRoute.snapshot.params['expedienteId'];
    this.usuarioCreadorId = this.activatedRoute.snapshot.params['usuarioId'];
    this.initColumns();
    this.cargarEntidad();
    const infoInicioSesion = JSON.parse(
       sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
    this.tipoDocumentoUsuario = infoInicioSesion.tipoDocumento;
    this.numeroIdentificacion = infoInicioSesion.identificacion;

    this.getExpendienteDetail(this.expedienteId,this.tipoDocumentoUsuario,this.numeroIdentificacion);
    this.utilService.watch().subscribe(val => {
      this.showButton = val;
    });
    this.utilService.setIdEntidad(this.entidadId);
    // Se toma la información del usuario que inicia sesión

    this.isCreator = infoInicioSesion.idUsuario === +this.usuarioCreadorId;
    // Se asigna información a InfoPantallaDTO
    this.infoPantalla = {
      tituloPantalla: this.guiaText['expediente-titulo'],
      descripcionPantalla:
      this.guiaSupersaludText['descripcion-pantalla'],
      pasos: [
        {
          element: '#tour',
          popover: {
            title:this.guiaSupersaludText['tour-titulo'],
            description:
            this.guiaText['tour-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#navbarDropdownDetalle',
          popover: {
            title: this.guiaText['usuario-titulo'],
            description:
            this.guiaText['usuario-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#dropdownAlertasButton',
          popover: {
            title: this.guiaText['alertas-titulo'],
            description:
            this.guiaText['alertas-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#glosario',
          popover: {
            title: this.guiaText['glosario-titulo'],
            description:
            this.guiaText['glosario-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#informacion',
          popover: {
            title: this.guiaText['info-titulo'],
            description:
            this.guiaText['info-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#encabezado',
          popover: {
            title: this.guiaSupersaludText['encabezado-titulo'],
            description:
            this.guiaSupersaludText['encabezado-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#crearSolicitud',
          popover: {
            title: this.guiaSupersaludText['crear-solicitud-titulo'],
            description:
            this.guiaSupersaludText['crear-solicitud-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#historicoBtn',
          popover: {
            title: this.guiaSupersaludText['historico-titulo'],
            description:
            this.guiaSupersaludText['historico-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#documentos',
          popover: {
            title: this.guiaSupersaludText['documentos-titulo'],
            description: this.guiaSupersaludText['documentos-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#historico',
          popover: {
            title: this.guiaSupersaludText['historico-titulo'],
            description:
            this.guiaSupersaludText['historico-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#filtro',
          popover: {
            title: this.guiaSupersaludText['filtro-titulo'],
            description:
            this.guiaSupersaludText['filtro-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#actuacion',
          popover: {
            title: this.tableText['actuacion'],
            description: this.guiaSupersaludText['actuacion-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#fecha',
          popover: {
            title: this.tableText['fecha'],
            description:
            this.guiaSupersaludText['fecha-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
      ],
    };
    // Se valida que sea el primer inicio de sesión para ejecutar la guía interactiva
    const isShowGuia = sessionStorage.getItem(Constants.SHOW_GUIA_DETALLE_SUPERSALUD) != null ? false : this.showGuia
    // Se valida que sea el primer inicio de sesión para ejecutar la guía interactiva
    if (infoInicioSesion.primerInicioSesion && isShowGuia) {
      this.utilService.changeInfoPantalla(this.infoPantalla);
      this.utilService.iniciarGuiaInteractiva();
      sessionStorage.setItem(Constants.SHOW_GUIA_DETALLE_SUPERSALUD, 'false')
    } else {
      this.utilService.changeInfoPantalla(this.infoPantalla);
    }
  }

  getExpendienteDetail(expedienteId: number,tipoDocumentoUsuario:string,numeroIdentificacion:string) {
    this.service.getExpedienteSuperSalud(expedienteId,tipoDocumentoUsuario,numeroIdentificacion).subscribe({
      next: data => {
        this.expedienteData = data;
        this.actuacionesSupersalud = this.expedienteData.actuaciones!;
        this.initColumns();
      },
      error: err => {
        console.error('Error getting data', err);
      },
    });
  }

  initColumns() {
    this.columns = [
      {
        field: 'actuacion',
        title: this.tableText['actuacion'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'actuacion',
      },
      {
        field: 'fecha',
        title: this.tableText['fecha'],
        type: 'date',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'fecha',
        pipe: 'dd/MM/yyyy',
      },
    ];
  }

  crearAvanceProcesal() {
    this.router.navigate([
      `expediente/${this.entidadId}/avance-procesal/${this.expedienteId}`,
    ]);
  }

  navigateAvanceProcesalSolicitudes() {
    this.router.navigate([
      `expediente/${this.entidadId}/avance-procesal/${this.expedienteId}/solicitudes`,
    ]);
  }

  openModal(): void {
    const modalData: any = {
      entidadId: this.entidadId,
      expedienteId: this.expedienteId,
      numeroProceso: this.expedienteData?.numero_proceso,
    };

    this.modalService.openModal(SolicitudDocumentosComponent, modalData);
  }

  cargarEntidad(): void {
    this.entidadService.obtenerEntidadPorId(this.entidadId).subscribe({
      next: (data) => {
        this.entidad = data;
      },
      error: (error) => console.error('Error al obtener la entidad:', error),
    });
  }
}
